import React from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { NotificationContainer } from "react-notifications";
import HomePage from "./shared/pages/Home";
import RootLayout from "./shared/pages/Root";
import TeacherDirectory from './components/TeacherDirectory/pages/TeacherDirectory';
import FirstFormPageDetails from "./components/EnglishCourseDetails/FirstFormDetails/FirstFormPageDetails/FirstFormPageDetails";
import SecondFormPageDetails from "./components/EnglishCourseDetails/SecondFormDetails/SecondFormPageDetails/SecondFormPageDetails";
import ThirdFormPageDetails from "./components/EnglishCourseDetails/ThirdFormDetails/ThirdFormPageDetails/ThirdFormPageDetails";
import FourthFormPageDetails from "./components/EnglishCourseDetails/FourthFormDetails/FourthFormPageDetails/FourthFormPageDetails";
import FrenchPageDetails from "./components/FrenchCourseDetails/FrenchPageDetails/FrenchPageDetails";
import Highlights from "./components/Highlights/HighlightsPage/Highlights";
import MemoriesPage from "./components/Highlights/HighlightsPage/HighlightsDirectory/MemoriesPage/MemoriesPage";
import 'react-notifications/lib/notifications.css';
import './App.css';



const router = createBrowserRouter([
  {
    path: '/',
    element: <RootLayout />,
    children: [
      { index: true, element: <HomePage />},
      { path: '/FirstFormPageDetails', element: <FirstFormPageDetails />},
      { path: '/SecondFormPageDetails', element: <SecondFormPageDetails />},
      { path: '/ThirdFormPageDetails', element: <ThirdFormPageDetails />},
      { path: '/FourthFormPageDetails', element: <FourthFormPageDetails />},
      { path: '/Teachers', element: <TeacherDirectory />},
      { path: '/FrenchPageDetails', element: <FrenchPageDetails />},
      { path: '/Highlights', element: <Highlights />},
      { path: '/Highlights/Memories', element: <MemoriesPage />},
    ],
  },
]);


function App() {
  return (
    <>
      <RouterProvider router={router} />
      <NotificationContainer />
    </>
  );
}

export default App;
